import React, { FC } from 'react';
import { ColorFunction } from '@styles/colors/types';
import { Text, View } from 'react-native';
import { font } from '@styles/fonts';
import ShortTimeDisplay from './ShortTimeDisplay';
import { TIME_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { ContainerStyle } from '@interfaces/base';
import TimeDisplay from '@components/common/TimeDisplay';
import { scale } from '@components/frame';

export interface InfoColumnProps extends ContainerStyle {
  label: string;
  C: ColorFunction;
  value?: string;
  valueColor?: string;
  targetDuration?: number;
  isShortTime?: boolean;
  longestLabel?: string;
}

export const InfoColumn: FC<InfoColumnProps> = ({ label, C, value, valueColor, targetDuration, isShortTime, longestLabel, containerStyle }) => {
  const fontStyles = font.Footnote;
  const textColor = C('Label/Light/Tertiary');

  const shouldReserveWidth = longestLabel != null && longestLabel.length > label.length;

  return (
    <View style={[containerStyle]}>
      <View>
        {shouldReserveWidth && <Text style={[fontStyles, { color: 'transparent' }]}>{longestLabel}</Text>}
        <Text style={[fontStyles, { color: textColor }, shouldReserveWidth && { position: 'absolute' }]}>{label}</Text>
      </View>
      <View style={{ flexBasis: scale(22), justifyContent: 'center', minHeight: scale(22) }}>
        {isShortTime && targetDuration != null ? (
          <ShortTimeDisplay targetDuration={targetDuration} color={'Time/Light/Actual'} />
        ) : (
          <TimeDisplay
            withHMSFormat
            value={value ?? TIME_CONFIG.placeholder}
            color={valueColor}
            C={C}
            fontForDigit={TIME_CONFIG.hmsFormatDigitFont}
            fontForSecondDigit={TIME_CONFIG.hmsFormatDigitFont}
            alreadyConverted
          />
        )}
      </View>
    </View>
  );
};
